// Angular
import { Component, OnInit, ViewChild } from '@angular/core';

// localforage
import * as localforage from 'localforage';

// Router animations
import { routerTransition } from '@app/router.animations';

// Services
import { ApiService } from '@app/services/api/api.service';

// components
import { AdminGuestSelectComponent } from '@app/containers/admin-guest-select/admin-guest-select.component';

@Component({
  selector: 'oh-root',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss'],
  animations: [routerTransition],
})
export class AdminDashboardComponent implements OnInit {
  private token: any;
  private data: any;
  public submissions: any;
  public questions: any;
  public allowImport: boolean;
  public total: number;
  public openHouse: any;
  @ViewChild(AdminGuestSelectComponent, { static: true }) adminGuestSelectComponent: any;

  constructor(private apiService: ApiService) {}

  async ngOnInit() {    
    this.token = await this.apiService.getTokenFromDatabase();

    try {
      await this.getData();
    } catch (error) {
      console.log(error);
    }
  }

  getSelectedGuest() {
    return this.adminGuestSelectComponent.selectedGuest;
  }

  async getData() {

    // Get the selected open house and its survey responses
    try {
      this.openHouse = await localforage.getItem('oh-selected-open-house');

      if (this.openHouse) { // Wait until we have the open house info
        if (navigator.onLine) {
          try {
            this.submissions = await this.apiService.getSurveySubmissions(this.token, this.openHouse); // Get submissions from the API
          } catch (error) {
            console.error(error);
          }
        } else { // Unable to pull submissions from the API
          try {
            this.submissions = await localforage.getItem('oh-survey-submissions'); // Get submissions from localforage
          } catch (error) {
            console.error(error);
          }
        }

        if (!this.submissions) {
          this.submissions = [];
        }
      }
    } catch (error) {
      console.error(error);
    }

    // Get the agent survey questions and the auto import status
    try {
      // Get the agent data array
      this.data = await this.apiService.getAgentDataFromDatabase();

      // Get the agent questions
      var surveyQuestions = this.data.survey_questions;
      this.total = surveyQuestions.length;
      this.questions = [];
      for (var i = 0; i < this.total; ++i) {
        this.questions[surveyQuestions[i].question_id] = surveyQuestions[i];
      }

      // Check if auto import is enabled (if auto import is on, then allow manual import should be off)
      this.allowImport = !this.data.auto_import;

    } catch (error) {
      console.error(error);
    }

  }

}
